import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, HostBinding, NgModule } from '@angular/core';
import { ci } from '@coyoapp/icons';
import * as i1 from '@ngneat/svg-icon';
import { SvgIconsModule } from '@ngneat/svg-icon';

/**
 * An SVG icon.
 *
 * `cui-icon` makes it easier to use vector-based icons. All icons must be
 * registered vie the `SvgIconRegistry`. The COYO icon set is registered by
 * default.
 *
 * Icons inherit the current <b>font color</b> and <b>size</b> by default.
 * Thus, they can be styled using the `font-size` and `color` properties.
 * The `size` input can also be used to quickly adjust the size of an icon.
 */
class IconComponent {
    constructor() {
        /**
         * The name of the icon.
         */
        this.name = 'emblem-coyo';
        /**
         * The size of the icon.
         */
        this.size = 'm';
    }
}
IconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.1", type: IconComponent, selector: "cui-icon", inputs: { name: "name", size: "size" }, host: { properties: { "attr.data-cui-size": "this.size" }, classAttribute: "cui-icon" }, ngImport: i0, template: "<svg-icon [key]=\"name\"></svg-icon>\n", styles: [".cui-icon{display:inline-flex;flex-shrink:0;vertical-align:middle}.cui-icon svg-icon{display:inline-flex}.cui-icon[data-cui-size=xs]{font-size:.75rem}.cui-icon[data-cui-size=s]{font-size:1rem}.cui-icon[data-cui-size=m]{font-size:1.25rem}.cui-icon[data-cui-size=l]{font-size:1.5rem}.cui-icon[data-cui-size=xl]{font-size:1.75rem}\n"], components: [{ type: i1.SvgIconComponent, selector: "svg-icon", inputs: ["key", "size", "width", "height", "fontSize", "color", "noShrink"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cui-icon', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, host: {
                        class: 'cui-icon'
                    }, template: "<svg-icon [key]=\"name\"></svg-icon>\n", styles: [".cui-icon{display:inline-flex;flex-shrink:0;vertical-align:middle}.cui-icon svg-icon{display:inline-flex}.cui-icon[data-cui-size=xs]{font-size:.75rem}.cui-icon[data-cui-size=s]{font-size:1rem}.cui-icon[data-cui-size=m]{font-size:1.25rem}.cui-icon[data-cui-size=l]{font-size:1.5rem}.cui-icon[data-cui-size=xl]{font-size:1.75rem}\n"] }]
        }], propDecorators: { name: [{
                type: Input
            }], size: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.data-cui-size']
            }] } });

function filter([name, data]) {
    return ({ name, data });
}
const iconModuleProviders = SvgIconsModule.forRoot({
    icons: Object.entries(ci).map(filter),
    defaultSize: 'md',
    sizes: { md: 'inherit' }
}).providers || [];
class IconModule {
    static forRoot() {
        return {
            ngModule: IconModule,
            providers: iconModuleProviders
        };
    }
}
IconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: IconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: IconModule, declarations: [IconComponent], imports: [CommonModule,
        SvgIconsModule], exports: [IconComponent] });
IconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: IconModule, imports: [[
            CommonModule,
            SvgIconsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        SvgIconsModule
                    ],
                    declarations: [
                        IconComponent
                    ],
                    exports: [
                        IconComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { IconComponent, IconModule, filter, iconModuleProviders };
